enum AddressComponentTypes {
  Country = 'country',
  StreetNumber = 'street_number',
  Route = 'route',
  Premise = 'premise',
  Locality = 'locality',
  Sublocality = 'sublocality',
  Province = 'administrative_area_level_1',
  City = 'locality',
  PinCode = 'postal_code',
}

const fetchAddressFromGeoCode = (
  addressComponents: google.maps.GeocoderAddressComponent[]
) => {
  const addressMap = addressComponents.reduce((acc, item) => {
    item.types.forEach(type => {
      acc[type] = item;
    });
    return acc;
  }, {} as Record<string, google.maps.GeocoderAddressComponent>);

  const streetLocality = `${
    addressMap[AddressComponentTypes.StreetNumber]?.long_name ?? ''
  } ${addressMap[AddressComponentTypes.Premise]?.long_name ?? ''} ${
    addressMap[AddressComponentTypes.Route]?.long_name ?? ''
  }`.trim();

  return {
    country: addressMap[AddressComponentTypes.Country],
    streetLocality,
    streetNumber: addressMap[AddressComponentTypes.StreetNumber],
    route: addressMap[AddressComponentTypes.Route],
    premise: addressMap[AddressComponentTypes.Premise],
    locality: addressMap[AddressComponentTypes.Locality],
    sublocality: addressMap[AddressComponentTypes.Sublocality],
    province: addressMap[AddressComponentTypes.Province],
    city: addressMap[AddressComponentTypes.City],
    pinCode: addressMap[AddressComponentTypes.PinCode],
  };
};

export default fetchAddressFromGeoCode;
